<template>
   <div class="grids">
					<div class="progressbar-heading grids-heading">
						<h2>Update Password</h2>
					</div>
					<div class="panel panel-widget forms-panel">
						<div class="forms">
							<div class="form-grids widget-shadow" data-example-id="basic-forms"> 
								
								<div class="form-body">
									<form v-on:submit.prevent="handleSubmit()"> 
                                        <div class="form-group">
                                      <label for="exampleInputPassword1">Password</label> 
                                      <input type="password" class="form-control" v-model="password" id="exampleInputPassword1" placeholder="Password">
                                       </div> 
                                     <div class="form-group">
                                      <label for="exampleInputPassword2">Password</label> 
                                      <input type="password" class="form-control" v-model="passwordConf" id="exampleInputPassword2" placeholder="Confirm Password">
                                       </div> 
                                     
                                        
                                          <button type="submit" class="btn btn-default">Submit</button>
                                           </form> 
								</div>
							</div>
						</div>
					</div>
			
                   
				
					
				</div>
</template>

<script>
import axios from "axios";
export default {
  name: 'About',
  props: {
      hash: 
    {
     type: String,
      required: true
  }
},
data()
{
	return{
		 hashValue: null,
        searchResults: [],
		tokenPresence: false,
		password: null,
		passwordConf: null
	}
},
async mounted()
{
    this.hashValue = this.hash;

    //check presence of access token
     //check for token and redirect to dashboard
     let accessToken = localStorage.getItem("token");
       if(accessToken !== "noToken")
        {
         if(accessToken !== null)
        {
           // alert(accessToken);
            this.tokenPresence = true;
            
        }
            
        }
       
       

        if(accessToken !== null)
        {
          if(accessToken !== "noToken")
        {
           // alert(accessToken);
            this.tokenPresence = true;
            
        }
            
        }
        

        if((accessToken != "noToken") && (accessToken !== null) && (this.tokenPresence == true))
        {
            this.$router.push("/timeawards/userDashboard");
        }

//fire axios request to verify hash then redirect to change password page

    if((this.hashValue == null) && (this.hashValue == ""))
    {
	 let Response = await axios({
       method: "get",
       url: `https://time-person-mofe.herokuapp.com/api/passwordReset/${this.hashValue}`,
     });

    if(Response.data.status != "success")
    {
          alert("Invalid reset hash");
          this.$router.push('/timeawards/');
    }
    
    }
    


},
methods:
{
	handleSubmit: async function()
	{
	try{
		    let Response = await axios({
       method: "post",
	   url: `https://time-person-mofe.herokuapp.com/api/passwordReset/${this.hashValue}`,
	   data:
	   {
		   passwordOne: this.password,
		   passwordTwo: this.passwordConf
	   }
     });

    if(Response.data.status == "success")
    {
		alert(Response.data.message);
          this.$router.push("/timeawards/signIn");
    }
    else{
       alert(Response.data.message);
     
    	}
	}
	catch(error)
	{
		alert(error);

	}
 
	}
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
